//import expand from "emmet";
import expand from "./emmet.es.js";

export function implode($c, $separator = ", ") {
  var $arr = [];

  if (!$c.length) return false;

  $c.forEach(function(entry) {
    $arr.push(entry);
  });

  return $arr.join($separator);
}

export default function el($vyraz, $val = false) {
  if ($val && _.isArray($val)) {
    return expand($vyraz + "{" + implode($val, "") + "}");
  } else if ($val) {
    return expand($vyraz + "{" + $val + "}");
  } else {
    return expand($vyraz);
  }
}
/*
export function get(obj, key) {
  return key.split(".").reduce(function(o, x) {
    return typeof o == "undefined" || o === null ? o : o[x];
  }, obj);
}

export function test() {
  Lc.h("tralala 25");
}

export function has(obj, key) {
  return key.split(".").every(function(x) {
    if (typeof obj != "object" || obj === null || !(x in obj)) return false;
    obj = obj[x];
    return true;
  });
}

*/

class Fce {
  has(obj, key) {
    return key.split(".").every(function(x) {
      if (typeof obj != "object" || obj === null || !(x in obj)) return false;
      obj = obj[x];
      return true;
    });
  }
  get(obj, key) {
    return key.split(".").reduce(function(o, x) {
      return typeof o == "undefined" || o === null ? o : o[x];
    }, obj);
  }
}

var MojeFce = new Fce();
export { MojeFce };

//var exports = {};
//exports.default = el;
